<template>
  <div class="donut-chart">
    <ul class="labels">
      <li v-for="item in dataset" :key="item.label">
        <div class="color" :style="{ 'background-color': item.color }" />
        <div class="text">{{ $t(item.label) }}</div>
      </li>
    </ul>
    <div class="donut-chart-wrapper" ref="wrapperRef" :style="{ width: `${w}px`, height: `${w}px` }">
      <canvas ref="chartRef" />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api';
import $ from 'jquery';

import Chart from '@/modules/chart';
import COLORS from '@/consts/colors';

export default {
  name: 'DonutChart',
  props: {
    dataset: {
      type: Array,
      required: true
    },
    width: {
      type: [String, Number],
      default: 0
    }
  },
  components: {
  },
  setup(props, { root }) {
    const wrapperRef = ref(null);
    const chartRef = ref(null);
    const chart = ref(null);

    const dataset = computed(() => props.dataset);

    const w = computed(() => {
      let ww = parseFloat(props.width);
      if (!ww) {
        ww = $(wrapperRef.value).width();
      }

      return ww;
    });

    watch([dataset, chart], ([set, newChart]) => {
      if (!newChart) return;
      const c = newChart;

      c.series = set.map((i) => i.value);
      c.labels = set.map((i) => root.$t(i.label));
      c.colors = set.map((i) => i.color);

      c.clear();
      c.drawDonut();
    }, {
      immediate: true
    });

    watch([w, chartRef], ([ww, newChartRef]) => {
      if (!newChartRef) return;

      const c = new Chart(newChartRef, ww * 2, ww * 2);
      c.textColor = COLORS.INDEPENDENCE;
      c.yPadding = 0;
      c.xPadding = 0;
      c.fontSize = 26;
      c.fontFace = 'Source Sans Pro';

      chart.value = c;
    }, {
      immediate: true
    });

    return {
      wrapperRef,
      chartRef,
      w
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.donut-chart {
  position: relative;

  .labels {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;

    li {
      .color {
        height: 10px;
        width: 30px;
        border-radius: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 7px;
      }

      .text {
        display: inline-block;
        font-size: 13px;
        vertical-align: middle;
      }
    }
  }

  .donut-chart-wrapper {
    margin: 0 auto;

    canvas {
      position: relative;
      top: 0;
      left: 0;
      transform: scale(.5);
      transform-origin: top left;
    }
  }
}
</style>
